(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magnekid-livre"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.mkl');
  if (!root) return;
  var session = new URLSearchParams(location.search).get('s');
  var endpoint = (root.dataset.endpoint || '').replace(/\/+$/, '');
  if (session && endpoint) {
    // replace(), not assign(): the back button should return the customer to their
    // order, not bounce them straight back here.
    location.replace(endpoint + '/book/' + encodeURIComponent(session));
    return;
  }
  var wait = root.querySelector('.mkl__wait');
  var lost = root.querySelector('.mkl__lost');
  if (wait) wait.hidden = true;
  if (lost) lost.hidden = false;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnekid-personaliser"] && !Shopify.designMode) return;
  try {
    
class MagneKidPersonaliser {
  constructor(root) {
    this.root = root;
    this.endpoint = root.dataset.endpoint;
    this.file = root.querySelector("input[type='file']");
    this.session = root.querySelector('.mk__session');
    this.book = root.querySelector('.mk__book');
    this.preview = root.querySelector('.mk__preview');
    this.generate = root.querySelector('.mk__generate');
    this.variants = root.querySelector('.mk__variants');
    this.gender = root.querySelector('.mk__gender');
    this.status = root.querySelector('.mk__status');
    this.submit = root.querySelector('.mk__submit');
    this.steps = root.querySelectorAll('.mk__step');

    this.lightbox = root.querySelector('.mk__lightbox');
    this.lightboxImg = this.lightbox && this.lightbox.querySelector('img');

    // How long a half-finished order is worth picking back up. Long enough to
    // survive a school run, short enough that a shared family tablet does not
    // hand the next person somebody else's child.
    this.ttl = 6 * 60 * 60 * 1000;

    this.file.addEventListener('change', () => this.onFile());
    this.generate.addEventListener('click', () => this.onGenerate());
    // Generating without a sex produces "a boy with her face", so the button waits.
    if (this.gender) {
      this.gender.addEventListener('change', () => this.refreshGenerate());
    }

    // Full-size view. The candidates are 1024px; the grid shows them at ~230px, so
    // a parent choosing on likeness cannot actually see the face they are judging.
    this.variants.addEventListener('click', (e) => {
      const zoom = e.target.closest('.mk__zoom');
      if (!zoom) return;
      e.preventDefault();
      const img = zoom.closest('.mk__variant').querySelector('img');
      if (!img || !img.getAttribute('src') || !this.lightbox) return;
      this.lightboxImg.src = img.src;
      this.lightbox.showModal();
    });
    if (this.lightbox) {
      this.lightbox.addEventListener('click', (e) => {
        // Clicking the backdrop closes; clicking the image itself does not.
        if (e.target === this.lightbox || e.target.closest('.mk__close')) {
          this.lightbox.close();
        }
      });
    }

    this.restore();
  }

  activate(n) {
    this.steps.forEach((s) => s.classList.toggle('is-active', Number(s.dataset.step) <= n));
  }

  /* ---- remembering the job -------------------------------------------------
     A render takes three to five minutes. Nobody watches a page for that long:
     they lock the phone, switch tabs, follow a link, or the browser discards the
     tab to save memory. Every one of those used to lose the order, because the
     session id lived only in a hidden field in this document - come back and you
     are looking at step one, with the render still running, unreachable, on a GPU
     that has already been paid for.

     So the id goes to localStorage the moment the server issues it, and the page
     picks the job back up on load. Reloading is now free instead of destructive. */

  key() { return 'mk:' + (this.root.dataset.comic || 'default'); }

  saved() {
    try {
      const raw = JSON.parse(localStorage.getItem(this.key()) || 'null');
      if (!raw || !raw.sid || Date.now() - (raw.at || 0) > this.ttl) return null;
      return raw;
    } catch (e) { return null; }
  }

  save(patch) {
    try {
      localStorage.setItem(this.key(),
        JSON.stringify(Object.assign(this.saved() || {}, patch)));
    } catch (e) { /* private mode or full: the page still works, just not across reloads */ }
  }

  forget() { try { localStorage.removeItem(this.key()); } catch (e) {} }

  /* The photo itself is never stored anywhere but the backend session. What is kept
     is a 320px JPEG of it, in this browser only, purely so the thumbnail in step 1
     comes back and a restored page looks like the one they left. */
  thumbnail(file) {
    return new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        try {
          const scale = Math.min(1, 320 / Math.max(img.width, img.height));
          const c = document.createElement('canvas');
          c.width = Math.round(img.width * scale);
          c.height = Math.round(img.height * scale);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          resolve(c.toDataURL('image/jpeg', 0.7));
        } catch (e) { resolve(''); }
        URL.revokeObjectURL(url);
      };
      img.onerror = () => { URL.revokeObjectURL(url); resolve(''); };
      img.src = url;
    });
  }

  /* A status line that never changes reads as "broken", and a cold GPU is slow
     enough for that to matter. Counts from when the job actually started, which on
     a restored page is well before this document existed. */
  countFrom(startedAt) {
    const waitText = this.root.dataset.working;
    const paint = () => {
      const s = Math.max(0, Math.round((Date.now() - startedAt) / 1000));
      const m = Math.floor(s / 60);
      this.status.textContent = waitText + ' (' + (m ? m + ' min ' : '') + (s % 60) + ' s)';
    };
    paint();
    return setInterval(paint, 1000);
  }

  async follow(data, startedAt) {
    const deadline = startedAt + 20 * 60 * 1000;
    while (data && data.status === 'pending' && Date.now() < deadline) {
      await new Promise((r) => setTimeout(r, 4000));
      try {
        const res = await fetch(data.poll, { cache: 'no-store' });
        const next = await res.json();
        if (next && next.status) data = next;
      } catch (e) { /* a dropped poll is not a failed render; keep asking */ }
    }
    return data;
  }

  show(data) {
    this.session.value = data.session_id || '';
    if (this.book) this.book.value = data.book_url || '';
    const imgs = this.variants.querySelectorAll('img');
    (data.previews || []).forEach((u, i) => { if (imgs[i]) imgs[i].src = u; });
    this.variants.hidden = false;
    this.status.textContent = this.root.dataset.choose;
    this.activate(2);

    const saved = this.saved();
    if (saved && saved.pick) {
      const radio = this.variants.querySelector('input[value="' + saved.pick.replace(/"/g, '') + '"]');
      if (radio) { radio.checked = true; this.onPick(); }
    }
  }

  /* The single place that decides what a finished poll means. Everything that can
     end a job routes through here, so there is exactly one rule about the boxes:
     they are revealed when there are images to put in them, and never before.
     An empty picker under "choose the one that looks most like them" is the bug
     this method exists to make impossible. */
  settle(data) {
    if (data && data.status === 'ready' && (data.previews || []).length) {
      this.show(data);
      this.save({ sid: data.session_id, ready: true });
      return;
    }
    this.variants.hidden = true;
    this.session.value = '';
    if (this.book) this.book.value = '';
    this.submit.disabled = true;
    this.status.textContent = (data && data.detail) || this.root.dataset.failed;
    if (!data || data.status === 'failed') this.forget();
  }

  async restore() {
    const saved = this.saved();
    if (!saved || !this.endpoint) return;

    if (saved.thumb) {
      this.preview.src = saved.thumb;
      this.preview.hidden = false;
    }
    this.activate(2);

    let data = null;
    try {
      const url = this.endpoint.replace(/\/+$/, '') + '/preview/' + encodeURIComponent(saved.sid);
      const res = await fetch(url, { cache: 'no-store' });
      if (res.status === 404) { this.forget(); return; }   // gone server-side
      data = await res.json();
    } catch (e) {
      return;              // offline or endpoint down: leave the form as it stands
    }

    if (data && data.status === 'pending') {
      const startedAt = saved.at || Date.now();
      const tick = this.countFrom(startedAt);
      data = await this.follow(data, startedAt);
      clearInterval(tick);
    }
    this.settle(data);
  }

  onFile() {
    const f = this.file.files && this.file.files[0];
    if (!f) return;
    this.preview.src = URL.createObjectURL(f);
    this.preview.hidden = false;
    this.refreshGenerate();          // a photo alone is not enough; the sex is required
    this.activate(2);
    this.thumbnail(f).then((t) => { this.thumb = t; });

    // Wake the GPU now, not when they press the button. The endpoint scales to zero,
    // so the first render after a quiet spell waits on a 9.4 GB model load. Choosing
    // a photo is a strong signal they are about to ask, and it buys that load half a
    // minute of their thinking time. Fire and forget - failure here is invisible.
    if (this.endpoint && !this.warmed) {
      this.warmed = true;
      fetch(this.endpoint.replace(/\/+$/, '') + '/warm', { method: 'POST' })
        .catch(() => {});
    }
  }

  async onGenerate() {
    // A restored page shows a thumbnail but holds no File - the browser will not
    // hand one back. Pressing "create" there means they want a different photo, so
    // open the picker rather than fail on an undefined file.
    const file = this.file.files && this.file.files[0];
    if (!file) { this.file.click(); return; }
    if (!this.endpoint) return;

    this.generate.disabled = true;
    this.submit.disabled = true;
    this.variants.hidden = true;          // the old three are not this child
    this.session.value = '';
    if (this.book) this.book.value = '';

    const startedAt = Date.now();
    const tick = this.countFrom(startedAt);
    if (!this.thumb) this.thumb = await this.thumbnail(file);

    let data = null;
    try {
      const base = this.endpoint.replace(/\/+$/, '');
      const body = new FormData();
      body.append('photo', file);
      body.append('comic', this.root.dataset.comic || '');
      body.append('gender', this.pickedGender() || '');
      // The server answers at once and renders in the background: the proxy in
      // front of it cuts any request off at ~100 s and a cold GPU takes minutes,
      // so waiting on one long response cannot work. 425 is that acceptance -
      // deliberately outside 2xx, so a client too old to poll takes its failure
      // path and says something true instead of revealing three empty boxes.
      const res = await fetch(base + '/preview', { method: 'POST', body });
      data = await res.json().catch(() => null);
      if (!res.ok && res.status !== 425) throw { detail: data && data.detail };
      if (!data || !data.session_id) throw {};

      // Written down before the wait, not after it. If the tab dies during those
      // minutes the render carries on regardless, and the next load finds it.
      this.save({ sid: data.session_id, at: startedAt, thumb: this.thumb || '', pick: '' });

      data = await this.follow(data, startedAt);
    } catch (e) {
      data = { status: 'failed', detail: e && e.detail };
    }

    clearInterval(tick);
    this.refreshGenerate();
    this.settle(data);
  }

  pickedGender() {
    const el = this.gender && this.gender.querySelector('input:checked');
    return el ? el.value : '';
  }

  // The generate button needs BOTH a photo and a sex. Either alone produces a preview
  // nobody wants: no photo means no child, no sex means the book's own boy in her place.
  refreshGenerate() {
    const hasPhoto = Boolean((this.file.files && this.file.files[0]) || this.thumb);
    this.generate.disabled = !(hasPhoto && this.pickedGender());
  }

  onPick() {
    // With an endpoint configured, no session means no book: do not take money. There is
    // nothing left to choose - the parent looks at two pages and buys - so the only gate
    // is that the preview actually produced a session.
    this.submit.disabled = Boolean(this.endpoint) && !this.session.value;
    this.activate(3);
  }
}

document.querySelectorAll('.mk').forEach((el) => new MagneKidPersonaliser(el));

// Undo a window scroll that should not be possible.
//
// This theme puts `overflow: hidden` on html and body at viewport height and scrolls
// a .page-wrapper div instead, so window.scrollY is always 0 in normal use. But the
// browser still scrolls the WINDOW to reveal a control that takes focus, and when the
// document is only one screen tall that drags the entire page above the viewport and
// leaves bare white canvas underneath. Measured in Firefox 154 after picking an
// option: html at y=-721, page-wrapper.scrollTop still 0, and nothing but the root
// element painted across two thirds of the screen. Chrome scrolls .page-wrapper
// instead, which is why this only ever appeared in Firefox.
//
// The condition is deliberately narrow: only when the document genuinely has nothing
// to scroll is a non-zero scrollY spurious. On a normal page this never fires.
addEventListener('scroll', function () {
  if (window.scrollY
      && document.documentElement.scrollHeight <= window.innerHeight + 1) {
    window.scrollTo(0, 0);
  }
}, { passive: true });

// Scroll to the personaliser ourselves rather than trusting the #hash.
//
// The theme ships view-transitions / section-hydration scripts that intercept link
// clicks to animate page changes. A same-page "#personnaliser" link gets caught by
// that machinery and swallowed: the CTA looks wired, the anchor target exists, and
// clicking does nothing at all. Handling it here in the capture phase takes the
// gesture back before anything else sees it, and works no matter which theme
// script is in front.
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('a[href="#personnaliser"]');
  if (!link) return;
  var target = document.getElementById('personnaliser');
  if (!target) return;
  e.preventDefault();
  e.stopPropagation();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  // Give the first field focus so a keyboard user lands somewhere useful too.
  var file = target.querySelector("input[type='file']");
  if (file) file.focus({ preventScroll: true });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
